import React, { FC } from 'react'
import s from "./CameraSettingDropdown.module.scss"
import { RangeValueSlider } from '../RangeValueSlider/RangeValueSlider';
import { CloseIcon } from '../../assets/svg/CloseIcon';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { updateCameraSettingEnabled } from '../../redux/reducers/ui/uiReducer';
import { getCameraEnabledSettings } from '../../redux/reducers/ui/uiSelectors';

export interface CameraSetting {
  label: string;
  unit: string;
  min: number | string;
  max: number | string;
  defaultValue: number;
  step?: number;
  showCheckbox?: boolean;
}

export interface CameraSettingDropdownProps {
  settings: CameraSetting[];
  onClose?: () => void;
  /** Called when a setting value changes: label and new value */
  onChangeSetting?: (label: string, value: number) => void;
  /** Called when a setting checkbox toggles: label and checked state */
  onToggleSetting?: (label: string, checked: boolean, value: number) => void;
}

export const CameraSettingDropdown: FC<CameraSettingDropdownProps> = ({ settings, onClose, onChangeSetting, onToggleSetting }) => {
  const dispatch = useAppDispatch();
  const enabledSettings = useAppSelector(getCameraEnabledSettings);
  
  // Map setting labels to Redux keys
  const getSettingKey = (label: string): "focalDistance" | "sensorWidth" | "exposure" | null => {
    switch (label) {
      case 'Focal distance': return 'focalDistance';
      case 'Sensor width': return 'sensorWidth';
      case 'Exposure': return 'exposure';
      default: return null;
    }
  };
  return (
      <div className={s.container}>
      <div className={s.cameraSetting}>
        <span>Camera settings</span>
        <div onClick={onClose} style={{ cursor: "pointer" }}>
          <CloseIcon />
        </div>
      </div>
      {settings.map((setting, idx) => (
        <div key={idx} className={s.settingRow}>
          <RangeValueSlider
            label={setting.label}
            unit={setting.unit}
            min={setting.min}
            max={setting.max}
            defaultValue={setting.defaultValue}
            step={setting.step}
            showCheckbox={setting.showCheckbox}
            checkboxChecked={enabledSettings[getSettingKey(setting.label) || 'sensorWidth'] || false}
            onCheckboxChange={(checked, value) => {
              const settingKey = getSettingKey(setting.label);
              if (settingKey) {
                dispatch(updateCameraSettingEnabled({ key: settingKey, enabled: checked }));
              }
              if (onToggleSetting) {
                onToggleSetting(setting.label, checked, value);
              }
            }}
            onChange={val =>
              onChangeSetting && onChangeSetting(setting.label, val)
            }
          />
        </div>
      ))}
    </div>
  );
}
